import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import socketIOClient from 'socket.io-client';

// import dotenv from "dotenv";

import UpdateInfo from './dialogs/UpdateInfo';
import './Components.css';

// const PORT = process.env.NODE_ENV==="production"?443:5000;
// const ENDPOINT = `http://localhost:${PORT}`;

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  signOutButton: {
    marginLeft: theme.spacing(1),
  }
}));

const Topbar = (props) => {
  const { className, onSidebarOpen, ...rest } = props;
  const [timestamp, setTimestamp] = useState("");
  const [socketResponse, setSocketResponse] = useState(null);

  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);

  const handleOpenUpdateDialog = () => {
    setOpenUpdateDialog(true);
  };
  const handleCloseUpdateDialog = () => {
    setOpenUpdateDialog(false);
  };

  useEffect(() => {
    const so = socketIOClient();
    so.on('broadcast', data => {
      if (data){
        const {author, commit} = data.values;
        let timeDateString = data.values.timestamp.split("T");
        let time = timeDateString[1];
        let date = timeDateString[0].split("-").reverse().join(".");
        setSocketResponse({values:{ author, commit, timestamp: date + " " + time}});
      } else { setSocketResponse( null ) };
    })
    const clock = setInterval(() => {
      let timestring = new Date().toLocaleString().replace(',', '').split('.');
      let state = [ timestring[0].padStart(2,"0"), timestring[1].padStart(2, "0"), timestring[2] ].join(".");
      setTimestamp(state);
    }, 1000);
    return () => {window.clearInterval(clock);so.disconnect()};
  },[]);

  const classes = useStyles();

  return (
    <div>
      <AppBar
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Toolbar>
          {/* <Hidden lgUp> */}
            <IconButton
              color="inherit"
              onClick={onSidebarOpen}
            >
              <MenuIcon />
            </IconButton>
            {
              socketResponse && 
              <div id='update-panel' onClick={handleOpenUpdateDialog}> 
                <p>Update am {socketResponse.values.timestamp}</p>
              </div>
            }
          {/* </Hidden> */}
          <div className={classes.flexGrow} />
          <p style={{fontFamily:'Arial, Helvetica, sans-serif', marginRight:50}}>
            {timestamp}
          </p>
          <div style={{display:'flex', flexDirection:'column', alignItems:'flex-end'}}>
            <p style={{fontFamily:'Arial, Helvetica, sans-serif'}}> 24h Service-Telefon </p>
            <p style={{fontFamily:'Arial, Helvetica, sans-serif'}}> +49 174 2476088 </p>
          </div>
        </Toolbar>
      </AppBar>
      {
        socketResponse && 
        <UpdateInfo open={openUpdateDialog} onClose={handleCloseUpdateDialog} info={socketResponse}/>
      }
    </div>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
